module.exports = __webpack_public_path__ + "images/shimo/document-new-5255f20444207dbc4113742df03e4f29.png";